import { useState } from 'react';

const EditActiveTrayDatePopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showEditActiveTrayDatePopup, setShowEditActiveTrayDatePopup] =
      useState<boolean>(false);

    const editActiveTrayToggleHandler = () => {
      setShowEditActiveTrayDatePopup(!showEditActiveTrayDatePopup);
    };

    return (
      <Component
        showEditActiveTrayDatePopup={showEditActiveTrayDatePopup}
        addActiveTrayDateToggleHandler={editActiveTrayToggleHandler}
        {...props}
      />
    );
  };

export default EditActiveTrayDatePopupHOC;
